import sqlFormatter from 'sql-formatter'
/**
 * Sets the proper indentation and then updates the reserved words to uppercase.
 * @param {String} queryText
 * @return {String} - Formatted query
 */
export function setUpQueryFormat (queryText) {
  if (!queryText) {
    return
  }

  queryText = indentQuery(queryText)
  queryText = formatKeywords(queryText)
  queryText = fixSplittedSentences(queryText)
  return queryText
}

/**
 * Formats a query with the propper indentation. Also, it places in one line sentences such as:
 * var between valueA and valueB
 * @param {String} queryText
 * @return {String} - Indented query
 */
const indentQuery = (queryText) => {
  // Format the query with the proper indentation.
  return sqlFormatter
    .format(queryText)
    .replace(/_ { {/g, '_{{')
    .replace(/} } _/g, '}}_')
    .replace(/{ {/g, '{{')
    .replace(/} }/g, '}}')
    .replace(/= >/g, '=>')
    .replace('< TABLE_NAME >', '<TABLE_NAME>')
    .replace('< CONDITION >', '<CONDITION>')
}

/**
 * Change keywords from lowercase to uppercase.
 * @param {String} queryText
 * @return {String} - Query with keywords in uppercase
 */
const formatKeywords = (queryText) => {
  /**
   * TODO: Find a better way to uppercase keywords without using "forEach"
   */
  const keyWords = [
    'with',
    'select',
    'distinct ',
    'from',
    'where',
    'group by',
    'order by',
    'limit',
    'left join',
    'right join',
    'inner join',
    'outter join',
    'join',
    'update',
    'delete',
    'alter',
    'union',
    'sum\\(',
    'count\\(',
    'round\\(',
    'concat\\(',
    'avg\\(',
    'flatten\\(',
    'dateadd\\(',
    'convert_timezone\\(',
    'date_trunc\\(',
    'rank\\(',
    ' in\\(',
    ' over\\(',
    ' asc',
    ' desc',
    ' null',
    ' case',
    ' then',
    ' and',
    ' when ',
    ' else ',
    ' end ',
    ' or ',
    ' on ',
    ' as ',
    ' between ',
    ' not ',
    ' in ',
    ' over ',
    ' cast ',
    ' having ',
    ' partition '
  ]

  keyWords.forEach(word => {
    const regEx = new RegExp(word, 'gi')
    queryText = queryText.replace(regEx, word.replace(/\\/, '').toUpperCase())
  })

  return queryText
}

/**
 * Fix splitted sentences when they are in two or more lines.
 * @param {String} queryText
 * @return {String} - Fixed query
 */
const fixSplittedSentences = (queryText) => {
  // Format the query with the proper indentation and split it in lines.
  const codeLines = queryText.split('\n')
  const codeFormatted = []

  // Flag used to know if it will be necessary to skip a line from the array.
  let skipLine = false

  // Evaluate each code line in order to check if there is any line with a 'between' sentence but
  // without its proper 'and' condition for ranges. For example: "and shift_day between '2019-12-01'"
  codeLines.forEach((line, index) => {
    // If the "skipLine" flag is on, jump to tne next code line.
    if (skipLine) {
      skipLine = false
      return
    }

    let newLine = line

    // If the current code line contains a "between" sentence but without its proper "and" condition,
    // then concatenate the next line into the current line and activate the flag to skip the next line.
    if (newLine.trim().match(' BETWEEN ') && newLine.trim().lastIndexOf('AND ') <= 0) {
      // Prevent out of boundary.
      const nextCodeLine = codeLines[index + 1] || ''

      // Validate the next code line has the missing "and" sentence for "between".
      if (nextCodeLine.includes('AND ')) {
        newLine += ` ${nextCodeLine.trim()}`
        skipLine = true
      }
    }

    codeFormatted.push(newLine)
  })

  // Set the new formatted code into the proper codemirror editor.
  return codeFormatted.join('\n')
}
